import { PropsWithChildren } from 'react';
import useAuth from 'hooks/auth/useAuth';
import NewLayout from './NewLayout';
import OldLayout from './OldLayout';
import useIsNewLayoutPage from 'hooks/ui/useIsNewLayoutPage';
import LayoutContextProvider from 'contexts/LayoutContext';
import useAvailableVehicles from 'hooks/lp/data/vehicle/useAvailableVehicles';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { realm, actionableError } = useAuth();
  const isNewLayoutPage = useIsNewLayoutPage();
  const { availableVehicles, isLoading } = useAvailableVehicles(realm);

  if (actionableError) {
    return <>{children}</>;
  }

  if (!realm || isLoading) {
    return null;
  }

  return (
    <LayoutContextProvider availableVehicles={availableVehicles}>
      {isNewLayoutPage ? (
        <NewLayout>{children}</NewLayout>
      ) : (
        <OldLayout>{children}</OldLayout>
      )}
    </LayoutContextProvider>
  );
};

export default Layout;
